<template>
  <div
    class="form-popup flex flex-row align-items-center"
    :class="{ show: isShow }"
    @click.self="config.allowClose ? closePopup() : null"
  >
    <div :class="'form-popup-content ' + config.size" v-if="isShow">
      <div class="form">
        <div
          class="form-popup-header px-2 pt-3"
          :class="haveFinance ? 'pb-0' : 'pb-3'"
        >
          <h4 class="m-0" v-html="config.title || 'Thêm mới'"></h4>
        </div>
        <p v-if="config.note" class="p-2">
          <span class="text-muted">{{ config.note }}</span>
        </p>
        <FormData
          v-if="isShow"
          v-show="tabActive == 'form'"
          :isPopup="true"
          :inputs="inputs"
          :isSending="sending"
          :isWarning="warning"
          :key="formKey"
          @onSubmit="onSubmit"
          @onChange="onChange"
          @onClose="closePopup()"
          :error="error"
          ref="formData"
          :overflow="config.overflow || 'auto'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FormData from "./FormData.vue"

export default {
  components: { FormData },
  name: "FormPopup",
  data: function () {
    return {
      config: {},
      inputs: [],
      sending: false,
      warning: false,
      isShow: false,
      haveFinance: false,

      tabActive: "form",
      financeObj: {},
      error: "",
      // Recreate FormData on every open so stateful controls (selects, dates,
      // editors, etc.) always receive the values for the selected record.
      formKey: 0,
    }
  },

  watch: {
    "$route.path"() {
      this.closePopup()
    },
  },

  methods: {
    onChange() {},
    openPopup(inputs, config = {}, cb) {
      if (this.functionListener) {
        document.removeEventListener("keydown", this.functionListener)
      }
      this.sending = false
      this.output = {}
      this.error = ""
      this.inputs = inputs
      this.config = config
      this.haveFinance = false
      this.tabActive = "form"
      if (config.finance) {
        this.financeObj = config.finance
        this.haveFinance = true
      }
      this._ok = cb
      this.formKey += 1
      this.functionListener = (e) => {
        if (e.key === "Escape") {
          this.closePopup()
        }
      }
      this.isShow = true

      document.addEventListener("keydown", this.functionListener)
    },
    setData(key, value) {
      this.$refs.formData.setData(key, value)
    },
    setAttr(key, type, value) {
      this.$refs.formData.setAttr(key, type, value)
    },
    setAttrs(d) {
      this.$refs.formData.setAttrs(d)
    },
    closePopup() {
      this.isShow = false
      if (this.functionListener) {
        document.removeEventListener("keydown", this.functionListener)
      }
    },
    setError(message) {
      this.error = message
    },
    close() {
      this.closePopup()
    },
    async onSubmit(e) {
      this._ok(e)
    },
  },
}
</script>
